import type React from 'react';
import { useState } from 'react';
import warningIcon from '~/static/assets/icons/warning-ico.svg';

interface MeetingErrorPageProps {
  meetingId: string;
  errorDetail?: string;
  title?: string;
  description?: string;
  onRetry?: () => void;
  onBackToHome: () => void;
}

export const MeetingErrorPage: React.FC<MeetingErrorPageProps> = ({
  meetingId,
  errorDetail,
  title = 'Meeting link expired or not valid.',
  description = 'Please schedule or start a new meeting at the Home page.',
  onRetry,
  onBackToHome,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <main className="meeting-error-page" aria-labelledby="meeting-error-title">
      <div className="meeting-error-page__card">
        <div className="meeting-error-page__icon-wrapper">
          <img src={warningIcon.src} alt="" width="40" height="40" aria-hidden="true" />
        </div>

        <h1 id="meeting-error-title" className="meeting-error-page__title">
          {title}
          {errorDetail && (
            <button
              type="button"
              className="meeting-error-page__info-icon"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              onFocus={() => setShowTooltip(true)}
              onBlur={() => setShowTooltip(false)}
              aria-label="Show error details"
            >
              &#9432;
              {showTooltip && (
                <span className="meeting-error-page__tooltip" role="tooltip">
                  {errorDetail}
                </span>
              )}
            </button>
          )}
        </h1>

        <p className="meeting-error-page__meeting-id">{meetingId}</p>

        <p className="meeting-error-page__description">{description}</p>

        <div className="meeting-error-page__actions">
          <button
            type="button"
            onClick={onBackToHome}
            className="meeting-error-page__button meeting-error-page__button--primary"
          >
            Back to Home
          </button>
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="meeting-error-page__button meeting-error-page__button--secondary"
            >
              Retry
            </button>
          )}
        </div>
      </div>
    </main>
  );
};
